import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, transitions } = theme;
  const { transparentSidenav, whiteSidenav, miniSidenav, darkMode } = ownerState;

  const { transparent, gradients, white, background } = palette;
  let backgroundValue = darkMode
    ? background.sidenav
    : gradients.dark.main

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  const commonDrawerStyles = {
    padding: 0,
    position: 'fixed',
    left: 0,
    margin: 0,
    boxSizing: 'border-box',
    borderRadius: 0,
    height: '100vh'
  };

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    ...commonDrawerStyles,
    background: backgroundValue,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    })
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    ...commonDrawerStyles,
    background: backgroundValue,
    height: 40, 
    overflow: 'hidden', 
    transition: transitions.create(["width", "height"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    })
  });

  return {
    "& .MuiDrawer-paper": {
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
